(function () {
  'use strict';

  var carouselSelector = [
    '.rr-best-sellers__grid',
    '.rr-home-products',
    '.rr-perfume-editorial__ritual-grid',
    '.rr-product-editorial__ritual-grid',
    '.rr-skin-quiz__product-grid',
    '.product-recommendations .product-list',
    '.section-featured-collection .product-list:not(.carousel)'
  ].join(',');

  var evaluatedTracks = [];
  var resizeTimer;
  var mutationTimer;
  var mutedVideos = typeof WeakSet === 'function' ? new WeakSet() : null;

  function makeArrow(direction) {
    var button = document.createElement('button');
    var isPrevious = direction === 'previous';

    button.type = 'button';
    button.className = 'rr-product-carousel__arrow rr-product-carousel__arrow--' + direction;
    button.setAttribute('aria-label', isPrevious ? 'Produits précédents' : 'Produits suivants');
    button.innerHTML = isPrevious
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"></path></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"></path></svg>';

    return button;
  }

  function ensureControls(track) {
    var parent = track.parentElement;
    var controls;
    var previous;
    var next;

    if (!parent) return null;

    parent.classList.add('rr-product-carousel');
    controls = parent.querySelector(':scope > .rr-product-carousel__controls');

    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'rr-product-carousel__controls';
      controls.hidden = true;
      previous = makeArrow('previous');
      next = makeArrow('next');
      controls.appendChild(previous);
      controls.appendChild(next);
      parent.appendChild(controls);

      previous.addEventListener('click', function () {
        track.scrollBy({ left: -Math.max(track.clientWidth * 0.88, 260), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: Math.max(track.clientWidth * 0.88, 260), behavior: 'smooth' });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () { updateControls(track); });
      }, { passive: true });
    }

    return controls;
  }

  function updateControls(track) {
    var parent = track.parentElement;
    var controls = parent && parent.querySelector(':scope > .rr-product-carousel__controls');
    var previous;
    var next;
    var maxScroll;

    if (!controls) return;

    maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    controls.hidden = maxScroll <= 3;
    if (controls.hidden) return;

    previous = controls.querySelector('.rr-product-carousel__arrow--previous');
    next = controls.querySelector('.rr-product-carousel__arrow--next');
    previous.disabled = track.scrollLeft <= 3;
    next.disabled = track.scrollLeft >= maxScroll - 3;
  }

  function resetTrackLayout(track) {
    track.classList.remove(
      'rr-product-carousel__track',
      'rr-product-carousel__track--converted',
      'rr-product-carousel__track--native'
    );
    track.style.removeProperty('--rr-product-carousel-gap');
    track.style.removeProperty('--rr-product-carousel-item-width');
  }

  function evaluateTrack(track) {
    var items;
    var firstTop;
    var firstRowCount;
    var computed;
    var gap;
    var wrapped;
    var alreadyScrollable;
    var controls;

    if (!track || !track.isConnected || track.closest('.mobile-navigation-drawer')) return;

    resetTrackLayout(track);
    items = Array.prototype.filter.call(track.children, function (item) {
      return item.nodeType === 1 && !item.hidden;
    });
    controls = ensureControls(track);

    if (!controls || items.length < 2 || track.clientWidth < 40) {
      if (controls) controls.hidden = true;
      return;
    }

    firstTop = items[0].offsetTop;
    firstRowCount = items.filter(function (item) {
      return Math.abs(item.offsetTop - firstTop) < 3;
    }).length;
    computed = window.getComputedStyle(track);
    gap = parseFloat(computed.columnGap || computed.gap) || 0;
    wrapped = firstRowCount > 0 && firstRowCount < items.length;
    alreadyScrollable = track.scrollWidth > track.clientWidth + 3;

    if (wrapped) {
      track.style.setProperty('--rr-product-carousel-gap', gap + 'px');
      track.style.setProperty(
        '--rr-product-carousel-item-width',
        Math.max(1, (track.clientWidth - gap * (firstRowCount - 1)) / firstRowCount) + 'px'
      );
      track.classList.add('rr-product-carousel__track', 'rr-product-carousel__track--converted');
    } else if (alreadyScrollable) {
      track.classList.add('rr-product-carousel__track', 'rr-product-carousel__track--native');
    } else {
      controls.hidden = true;
      return;
    }

    window.requestAnimationFrame(function () { updateControls(track); });
  }

  function discoverCarousels(root) {
    var tracks = [];

    if (root && root.matches && root.matches(carouselSelector)) tracks.push(root);
    if (root && root.querySelectorAll) {
      tracks = tracks.concat(Array.prototype.slice.call(root.querySelectorAll(carouselSelector)));
    }

    tracks.forEach(function (track) {
      if (evaluatedTracks.indexOf(track) === -1) evaluatedTracks.push(track);
      evaluateTrack(track);
    });
  }

  function reevaluateCarousels() {
    evaluatedTracks = evaluatedTracks.filter(function (track) { return track.isConnected; });
    evaluatedTracks.forEach(evaluateTrack);
    discoverCarousels(document);
  }

  function muteNativeVideo(video) {
    function enforceMute() {
      try {
        video.defaultMuted = true;
        video.muted = true;
        video.volume = 0;
      } catch (error) {
        /* Certains navigateurs protègent le volume : l'attribut muted reste appliqué. */
      }
    }

    if (!video || video.tagName !== 'VIDEO') return;
    enforceMute();

    if (!mutedVideos || !mutedVideos.has(video)) {
      video.setAttribute('muted', '');
      video.addEventListener('volumechange', enforceMute);
      video.addEventListener('play', enforceMute);
      if (mutedVideos) mutedVideos.add(video);
    }
  }

  function muteExternalFrame(frame) {
    var source = (frame.getAttribute('src') || '').toLowerCase();

    if (!frame.contentWindow) return;

    try {
      if (source.indexOf('youtube') !== -1 || source.indexOf('youtu.be') !== -1) {
        frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'mute', args: [] }), '*');
      } else if (source.indexOf('vimeo') !== -1) {
        frame.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: 0 }), '*');
      }
    } catch (error) {
      /* L'iframe reste isolée ; les lecteurs du thème sont également configurés en muet. */
    }
  }

  function muteAllMedia(root) {
    var videos = [];
    var frames = [];

    if (root && root.matches && root.matches('video')) videos.push(root);
    if (root && root.matches && root.matches('iframe')) frames.push(root);
    if (root && root.querySelectorAll) {
      videos = videos.concat(Array.prototype.slice.call(root.querySelectorAll('video')));
      frames = frames.concat(Array.prototype.slice.call(root.querySelectorAll('iframe')));
    }

    videos.forEach(muteNativeVideo);
    frames.forEach(function (frame) {
      muteExternalFrame(frame);
      if (!frame.dataset.rrMuteBound) {
        frame.dataset.rrMuteBound = 'true';
        frame.addEventListener('load', function () { muteExternalFrame(frame); });
      }
    });
  }

  function init(root) {
    discoverCarousels(root || document);
    muteAllMedia(root || document);
  }

  init(document);

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(reevaluateCarousels, 180);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  new MutationObserver(function (mutations) {
    window.clearTimeout(mutationTimer);
    mutationTimer = window.setTimeout(function () {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node.nodeType === 1) init(node);
          });
        } else if (mutation.target && mutation.target.nodeType === 1) {
          init(mutation.target);
        }
      });
    }, 80);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['hidden']
  });

  window.setInterval(function () {
    if (!document.hidden) muteAllMedia(document);
  }, 1200);
})();
